// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.settings-card {
    background: var(--card-bg);
    border: 1px solid var(--border-color);
    padding: 20px;
    border-radius: 12px;
    margin-bottom: 25px;
}

.settings-row {
    display: flex;
    flex-direction: column;
    margin-bottom: 15px;
}

.settings-row label {
    margin-bottom: 5px;
    opacity: 0.8;
}

.settings-row input,
.settings-row select {
    padding: 10px 14px;
    border-radius: 8px;
    border: 1px solid var(--border-color);
    background: var(--card-bg);
    color: var(--text-color);
}

.settings-card table {
    margin-top: 15px;
}

.settings-card .delete-btn {
    background: #e74c3c;
    border: none;
    padding: 6px 10px;
    border-radius: 6px;
    cursor: pointer;
    color: white;
}

.settings-card .delete-btn:hover {
    opacity: 0.8;
}

`, "",{"version":3,"sources":["webpack://./src/styles/Settings.css"],"names":[],"mappings":"AAAA;IACI,0BAA0B;IAC1B,qCAAqC;IACrC,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,YAAY;AAChB;;AAEA;;IAEI,kBAAkB;IAClB,kBAAkB;IAClB,qCAAqC;IACrC,0BAA0B;IAC1B,wBAAwB;AAC5B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB","sourcesContent":[".settings-card {\r\n    background: var(--card-bg);\r\n    border: 1px solid var(--border-color);\r\n    padding: 20px;\r\n    border-radius: 12px;\r\n    margin-bottom: 25px;\r\n}\r\n\r\n.settings-row {\r\n    display: flex;\r\n    flex-direction: column;\r\n    margin-bottom: 15px;\r\n}\r\n\r\n.settings-row label {\r\n    margin-bottom: 5px;\r\n    opacity: 0.8;\r\n}\r\n\r\n.settings-row input,\r\n.settings-row select {\r\n    padding: 10px 14px;\r\n    border-radius: 8px;\r\n    border: 1px solid var(--border-color);\r\n    background: var(--card-bg);\r\n    color: var(--text-color);\r\n}\r\n\r\n.settings-card table {\r\n    margin-top: 15px;\r\n}\r\n\r\n.settings-card .delete-btn {\r\n    background: #e74c3c;\r\n    border: none;\r\n    padding: 6px 10px;\r\n    border-radius: 6px;\r\n    cursor: pointer;\r\n    color: white;\r\n}\r\n\r\n.settings-card .delete-btn:hover {\r\n    opacity: 0.8;\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
